export const GIFT_IMAGE_FALLBACK = '/images/gifts/cherry.png';
export const CUSTOM_GIFT_IMAGE_FALLBACK = '/images/gifts/custom.png';
